import { Directive, HostListener, Input } from '@angular/core';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';

@Directive({
  selector: '[capslock]'
})
export class CapslockDetectorDirective extends TooltipDirective {
  @Input('capslock') capslock;
  ngOnInit() {
    this.placement = 'bottom';
    this.triggers = '';
    this.tooltip = this.capslock;
    super.ngOnInit();
  }
  @HostListener('keydown', ['$event'])
  public onKeyDown($event) {
    if ($event.getModifierState && $event.getModifierState('CapsLock')) {
      if (!this.isOpen) this.show();
    }
  }
  @HostListener('keyup', ['$event'])
  public onKeyUp($event) {
    if ($event.getModifierState && !$event.getModifierState('CapsLock')) {
      if (this.isOpen) this.hide();
    }
  }
  @HostListener('blur', ['$event'])
  public blur() {
    if (this._isOpen) this.hide();
  }
}
